import { apiClient } from './client.js';

export const learningPathApi = {
  /**
   * Lấy danh sách tất cả 3 lộ trình học đóng gói
   */
  getAllPaths: () => {
    return apiClient.get('/learning-paths');
  },

  /**
   * Lấy chi tiết một lộ trình học kèm danh sách bài học
   */
  getPathDetails: (idOrSlug) => {
    return apiClient.get(`/learning-paths/${idOrSlug}`);
  },
};
